import type React from "react";
import { FullscreenSpinner, Separator, XStack, YStack } from "@medbillai/ui";
import { PageHeader } from "../../components/PageHeader.web";
import { useAuth } from "../../lib/auth";
import { SettingsScreen } from "./screen";
type SettingsLayoutProps = {
  isSettingsHome?: boolean;
  children?: React.ReactNode;
};
export const SettingsLayout = ({
  children,
  isSettingsHome = false
}: SettingsLayoutProps) => {
  const {
    isReady,
    user
  } = useAuth();
  if (!isReady || !user) {
    return <FullscreenSpinner />;
  }
  return <YStack f={1} data-sentry-element="YStack" data-sentry-component="SettingsLayout" data-sentry-source-file="layout.web.tsx">
      <PageHeader title="Settings" data-sentry-element="PageHeader" data-sentry-source-file="layout.web.tsx" />
      <XStack f={1} borderTopWidth={1} borderColor="$strokeSecondary" data-sentry-element="XStack" data-sentry-source-file="layout.web.tsx">
        <YStack $sm={{
        flex: 1,
        display: isSettingsHome ? "flex" : "none"
      }}
      // this file is web-only so we can safely use CSS
      style={{
        transition: "200ms ease width"
      }} $gtSm={{
        width: 300
      }} $gtLg={{
        width: 400
      }} data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
          <SettingsScreen data-sentry-element="SettingsScreen" data-sentry-source-file="layout.web.tsx" />
        </YStack>
        <Separator vertical data-sentry-element="Separator" data-sentry-source-file="layout.web.tsx" />
        <YStack f={1} ai="flex-start" $sm={{
        display: isSettingsHome ? "none" : "block"
      }} data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
          <YStack width="100%" height="100%" f={1} justifyContent="center" alignItems="center" data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
            {children}
          </YStack>
        </YStack>
      </XStack>
    </YStack>;
};